import { InputFieldContainerProps } from '../common/InputFieldContainer';
import PasswordField from '../common/PasswordField';

export default function PasswordSection(props: InputFieldContainerProps) {
  return (
    <PasswordField {...props} />
  );
}
